'use client';

import { usePathname } from 'next/navigation';
import Header from './header/Header';

export default function ConditionalHeader() {
  const pathname = usePathname();

  // Скриваме Header на админ; при pathname undefined (SSR/кеш) не показваме header.
  if (pathname == null || pathname.startsWith('/admin')) {
    return null;
  }

  return <Header />;
}
